export default __webpack_public_path__ + "static/media/birthday_application.644f9d31.gif";